var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWebsite = function SvgWebsite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none",
    viewBox: "0 0 16 22"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#1F2D3D",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "m5.143 9.691.207-.207a5.067 5.067 0 1 1 7.166 7.166L9.65 19.516a5.067 5.067 0 1 1-7.166-7.166l.464-.464"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#1F2D3D",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "m13.052 10.114.464-.464A5.067 5.067 0 1 0 6.35 2.484L3.484 5.35a5.067 5.067 0 1 0 7.166 7.166l.207-.207"
  })));
};
export default SvgWebsite;